import React from 'react';
interface Props {
  fillColor?: string;
}
function PalliativeIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none">
      <path
        d="M7.05625 14.6329L6.97813 14.561L1.50312 9.47667C0.54375 8.58604 0 7.33604 0 6.02667V5.92354C0 3.72354 1.5625 1.83604 3.725 1.42354C4.95625 1.18604 6.21562 1.47042 7.21875 2.17667C7.5 2.37667 7.7625 2.60792 8 2.87354C8.13125 2.72354 8.27188 2.58604 8.42188 2.45792C8.5375 2.35792 8.65625 2.26417 8.78125 2.17667C9.78438 1.47042 11.0437 1.18604 12.275 1.42042C14.4375 1.83292 16 3.72354 16 5.92354V6.02667C16 7.33604 15.4563 8.58604 14.4969 9.47667L9.02188 14.561L8.94375 14.6329C8.6875 14.8704 8.35 15.0048 8 15.0048C7.65 15.0048 7.3125 14.8735 7.05625 14.6329ZM7.47188 4.53292C7.45938 4.52354 7.45 4.51104 7.44063 4.49854L6.88438 3.87354L6.88125 3.87042C6.15937 3.06104 5.06875 2.69229 4.00625 2.89542C2.55 3.17354 1.5 4.44229 1.5 5.92354V6.02667C1.5 6.91729 1.87188 7.77042 2.525 8.37667L8 13.461L13.475 8.37667C14.1281 7.77042 14.5 6.91729 14.5 6.02667V5.92354C14.5 4.44542 13.45 3.17354 11.9969 2.89542C10.9344 2.69229 9.84062 3.06417 9.12187 3.87042C9.12187 3.87042 9.12187 3.87042 9.11875 3.87354C9.11562 3.87667 9.11875 3.87354 9.11563 3.87667L8.55937 4.50167C8.55 4.51417 8.5375 4.52354 8.52812 4.53604C8.3875 4.67667 8.19687 4.75479 8 4.75479C7.80312 4.75479 7.6125 4.67667 7.47188 4.53604V4.53292Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default PalliativeIcon;
